"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSpid = exports.SpidContextProvider = exports.SpidContextConsumer = void 0;
var react_1 = __importStar(require("react"));
var mono_scc_1 = require("@snoam/mono-scc");
var identity_1 = __importDefault(require("@schibsted/account-sdk-browser/identity"));
var monetization_1 = __importDefault(require("@schibsted/account-sdk-browser/monetization"));
var asyncNoop = function () { return Promise.resolve(void 0); };
var SpidContext = react_1.createContext({
    actions: {
        checkLoginStatus: asyncNoop,
        logout: asyncNoop,
        login: asyncNoop,
        hasSession: asyncNoop,
        hasProduct: asyncNoop
    },
    state: {
        spidOptions: null,
        userId: null,
        sig: null,
        givenName: null,
        familyName: null,
        hasProduct: false,
        isLoaded: false
    }
});
__exportStar(require("@snoam/mono-scc"), exports);
exports.SpidContextConsumer = SpidContext.Consumer;
var isSuccessResponse = function (res) {
    return res.result && !!res.userId;
};
var redirectUri = function (isProd) { return "https://" + (isProd ? '' : 'test-') + "redirect.s-plat.no"; };
var isServer = function () { return typeof window === "undefined"; };
var getSpidConfig = function (domain, clientShortHandName, sessionDomain, siteSpecificLogout) {
    if (sessionDomain === undefined) {
        sessionDomain = ("https://id" + (mono_scc_1.isProduction(domain) ? '' : '-pre') + "." + mono_scc_1.mainHostnameFromHostname(domain)).replace(/\.lh$/, '.no');
    }
    return {
        clientId: mono_scc_1.getClientId(clientShortHandName || mono_scc_1.clientShortHandNameFromHostname(domain), mono_scc_1.isProduction(domain)),
        redirectUri: redirectUri(mono_scc_1.isProduction(domain)),
        env: mono_scc_1.isProduction(domain) ? 'PRO_NO' : 'PRE',
        sessionDomain: sessionDomain,
        siteSpecificLogout: (siteSpecificLogout === undefined ? true : siteSpecificLogout),
    };
};
var getSpidInstances = function (domain, clientShortHandName, sessionDomain, siteSpecificLogout) {
    if (isServer()) {
        return {
            identity: null,
            monetization: null,
            spidOptions: {}
        };
    }
    var spidOptions = getSpidConfig(domain, clientShortHandName, sessionDomain, siteSpecificLogout);
    var identity = new identity_1.default(spidOptions);
    identity._enableSessionCaching = false;
    var monetization = new monetization_1.default(spidOptions);
    return {
        identity: identity,
        monetization: monetization,
        spidOptions: spidOptions
    };
};
var getGlobalProductId = function () { return process.env.REACT_APP_SPID_PRODUCT_ID || (typeof window !== 'undefined' ? window.REACT_APP_SPID_PRODUCT_ID : 0); };
var SpidContextActions;
(function (SpidContextActions) {
    SpidContextActions[SpidContextActions["READY"] = 0] = "READY";
    SpidContextActions[SpidContextActions["USER_UPDATED"] = 1] = "USER_UPDATED";
    SpidContextActions[SpidContextActions["USER_RESET"] = 2] = "USER_RESET";
    SpidContextActions[SpidContextActions["HAS_PRODUCT"] = 3] = "HAS_PRODUCT";
})(SpidContextActions || (SpidContextActions = {}));
var reducer = function (state, action) {
    var type = action.type, payload = action.payload;
    var READY = SpidContextActions.READY, HAS_PRODUCT = SpidContextActions.HAS_PRODUCT, USER_RESET = SpidContextActions.USER_RESET, USER_UPDATED = SpidContextActions.USER_UPDATED;
    switch (type) {
        case READY:
            return __assign(__assign({}, state), { identity: payload.identity, monetization: payload.monetization, isLoaded: true });
        case HAS_PRODUCT:
            return __assign(__assign({}, state), { products: __assign(__assign({}, state.products), payload) });
        case USER_UPDATED:
            console.info("USER_UPDATED", payload);
            localStorage.setItem('token', payload.sig);
            return __assign(__assign({}, state), { user: payload });
        case USER_RESET:
            return __assign(__assign({}, state), { products: {}, user: {} });
    }
    return state;
};
var autoLoginInterval;
exports.SpidContextProvider = function (props) {
    var reload = props.reload, children = props.children, domain = props.domain, clientShortHandName = props.clientShortHandName, sessionDomain = props.sessionDomain, siteSpecificLogout = props.siteSpecificLogout, href = props.href, _a = props.teaser, teaser = _a === void 0 ? '' : _a, redirectPath = props.redirectPath, setPulseUser = props.setPulseUser, enableRefreshToken = props.enableRefreshToken;
    var _b = getSpidInstances(domain, clientShortHandName, sessionDomain, siteSpecificLogout), idt = _b.identity, mon = _b.monetization, spo = _b.spidOptions;
    var _c = react_1.useReducer(reducer, {
        identity: idt,
        monetization: mon,
        products: {},
        user: {},
        isLoaded: false,
    }), state = _c[0], dispatch = _c[1];
    var identity = state.identity, monetization = state.monetization, products = state.products;
    var hasSession = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    if (!identity) {
                        return [2, false];
                    }
                    return [4, identity.hasSession(true)];
                case 1:
                    response = _a.sent();
                    if (isSuccessResponse(response)) {
                        return [2, response];
                    }
                    throw response;
                case 2:
                    e_1 = _a.sent();
                    throw e_1;
                case 3: return [2];
            }
        });
    }); };
    var hasProduct = function (productId) { return __awaiter(void 0, void 0, void 0, function () {
        var user, result, e_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4, hasSession()];
                case 1:
                    user = _b.sent();
                    if (!monetization || !productId) {
                        return [2, false];
                    }
                    if (products.hasOwnProperty(productId)) {
                        return [2, products[productId]];
                    }
                    return [4, monetization.hasProduct(Number(productId), user.userId)];
                case 2:
                    result = _b.sent();
                    dispatch({ type: SpidContextActions.HAS_PRODUCT, payload: (_a = {}, _a[productId] = result, _a) });
                    return [2, result];
                case 3:
                    e_2 = _b.sent();
                    console.error(e_2);
                    return [2, false];
                case 4: return [2];
            }
        });
    }); };
    var checkProduct = function (productId) {
        if (productId === void 0) { productId = getGlobalProductId(); }
        return __awaiter(void 0, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, hasProduct(productId)];
                    case 1: return [2, _a.sent()];
                    case 2:
                        e_3 = _a.sent();
                        console.error(e_3);
                        return [2, false];
                    case 3: return [2];
                }
            });
        });
    };
    var autoLogin = function () { return __awaiter(void 0, void 0, void 0, function () {
        var user, e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, hasSession()];
                case 1:
                    user = _a.sent();
                    dispatch({ type: SpidContextActions.USER_UPDATED, payload: user });
                    checkProduct();
                    return [3, 3];
                case 2:
                    e_4 = _a.sent();
                    console.error(e_4);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var login = function (_a) {
        var _b = _a === void 0 ? {} : _a, redirectUri = _b.redirectUri, teaserOption = _b.teaser;
        return __awaiter(void 0, void 0, void 0, function () {
            var hasSession;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4, identity.getUserContextData()];
                    case 1:
                        hasSession = _c.sent();
                        if (!hasSession) return [3, 3];
                        return [4, identity.showSimplifiedLoginWidget({
                                state: JSON.stringify({ redirectUri: redirectUri || href }),
                                teaser: (teaserOption || teaser)
                            })];
                    case 2:
                        _c.sent();
                        return [3, 5];
                    case 3: return [4, identity.login({
                            state: JSON.stringify({ redirectUri: redirectUri || href }),
                            teaser: (teaserOption || teaser)
                        })];
                    case 4:
                        _c.sent();
                        _c.label = 5;
                    case 5: return [2];
                }
            });
        });
    };
    var logout = function (redirectUri) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isServer()) {
                        window.localStorage.removeItem('loginInProgress-cache');
                    }
                    return [4, identity.logout(redirectUri ? redirectUri : window.location.origin)];
                case 1:
                    _a.sent();
                    dispatch({ type: SpidContextActions.USER_RESET });
                    if (reload) {
                        reload();
                    }
                    return [2];
            }
        });
    }); };
    var checkLoginStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isLoggedIn, windowAsAny, spidState, loginURI, logoutURI, user, expiresIn;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, identity.isLoggedIn()];
                case 1:
                    isLoggedIn = _a.sent();
                    windowAsAny = window;
                    spidState = JSON.stringify({ redirectUri: window.location.href });
                    loginURI = identity.loginUrl(spidState);
                    logoutURI = identity.logoutUrl("" + (window.location.hostname.indexOf('localhost') !== -1 ? window.location.href : "https://" + window.location.hostname + "/" + (redirectPath ? redirectPath : 'minside') + "/"));
                    if (!isLoggedIn) return [3, 4];
                    return [4, identity.getUser()];
                case 2:
                    user = _a.sent();
                    if (setPulseUser) {
                        setPulseUser(user.userId);
                    }
                    dispatch({ type: SpidContextActions.USER_UPDATED, payload: user });
                    if (enableRefreshToken) {
                        expiresIn = user.expiresIn;
                        if (expiresIn > 21600) {
                            expiresIn = 21600;
                        }
                        clearInterval(autoLoginInterval);
                        autoLoginInterval = setInterval(autoLogin, (expiresIn - 15) * 1000);
                    }
                    if (windowAsAny.sndPaywallSession && windowAsAny.sndPaywallSession.mock) {
                        if (windowAsAny._coreHeader && windowAsAny._coreHeader.setSessionData) {
                            windowAsAny._coreHeader.setSessionData({
                                loggedIn: true,
                                givenName: user.givenName,
                                familyName: user.familyName,
                                userId: user.userId,
                                sig: user.sig,
                                loginURI: loginURI,
                                logoutURI: logoutURI,
                            });
                        }
                        if (windowAsAny.sndPaywallSession.Auth && windowAsAny.sndPaywallSession.Auth.logout) {
                            windowAsAny.sndPaywallSession.Auth.logout = function () { return identity.logout(window.location.href); };
                        }
                    }
                    return [4, checkProduct()];
                case 3:
                    _a.sent();
                    return [3, 5];
                case 4:
                    if (windowAsAny._coreHeader && windowAsAny._coreHeader.setSessionData) {
                        windowAsAny._coreHeader.setSessionData({
                            loginURI: loginURI,
                            logoutURI: logoutURI,
                        });
                    }
                    _a.label = 5;
                case 5:
                    dispatch({ type: SpidContextActions.READY, payload: { identity: identity, monetization: monetization } });
                    return [2];
            }
        });
    }); };
    var providerState = {
        actions: {
            checkLoginStatus: checkLoginStatus,
            hasProduct: hasProduct,
            hasSession: hasSession,
            login: login,
            logout: logout,
        },
        state: {
            spidOptions: spo,
            givenName: state.user ? state.user.givenName : null,
            familyName: state.user ? state.user.familyName : null,
            hasProduct: state.products[getGlobalProductId()] || false,
            isLoaded: state.isLoaded,
            sig: state.user ? state.user.sig : null,
            userId: state.user ? state.user.userId : null,
        }
    };
    react_1.useEffect(function () {
        window.addEventListener('load', addLoginWigetStyle, false);
        function addLoginWigetStyle() {
            var loginWigetStyle = document.createElement('style');
            loginWigetStyle.type = 'text/css';
            loginWigetStyle.innerHTML = '#simplified-login-widget {position: relative; z-index: 100;}';
            document.head.appendChild(loginWigetStyle);
        }
        return function () { return window.removeEventListener("load", addLoginWigetStyle); };
    }, []);
    react_1.useEffect(function () {
        if (isServer()) {
            return;
        }
        window.identity = identity;
        window.monetization = monetization;
    }, [state]);
    react_1.useEffect(function () {
        clearInterval(autoLoginInterval);
        checkLoginStatus();
        return function () {
            clearInterval(autoLoginInterval);
        };
    }, []);
    return (react_1.default.createElement(SpidContext.Provider, { value: providerState }, children));
};
exports.useSpid = function () {
    return react_1.useContext(SpidContext);
};
//# sourceMappingURL=spid.js.map